import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}/externalapi`
const testUrl = localStorage.getItem(TEST_URl)
const testBaseUrl = `${testUrl}/externalapi`

const baseUrl = testUrl ? testBaseUrl : defaultBaseUrl
export async function generateApiKeyService (payload) {
  const res = await axios.post(`${baseUrl}/api-credential`, { ...payload })
  return res
}
export async function saveWebhookService (payload) {
  const res = await axios.post(`${baseUrl}/webhook`, { ...payload })
  return res
}
export async function getApiCredentialsService () {
  const res = await axios.get(`${baseUrl}/api-credential`)
  return res
}
export async function getCustomersService (payload) {
  const hasSearch = payload.search ? `&name=${payload.search}` : ''
  const hasFrom = payload.from ? `&from=${payload.from}` : ''
  const hasTo = payload.to ? `&to=${payload.to}` : ''
  const res = await axios.get(
    `${baseUrl}/customers?page=${payload.page}&size=${payload.size}${hasSearch}${hasFrom}${hasTo}`
  )
  return res
}
export async function getCustomerDetailsService (id) {
  const res = await axios.get(`${baseUrl}/customer/${id}`)
  return res
}
export async function getCustomerDetailsTransactions (payload) {
  const hasType = payload.type ? `${payload.type}` : ''

  if (hasType) {
    const res = await axios.get(
      `${baseUrl}/transactions/${hasType}?customer-id=${payload.customerId}&page=${payload.page}&size=${payload.size}`
    )
    return res
  } else {
    const res = await axios.get(
      `${baseUrl}/transactions?customer-id=${payload.customerId}&page=${payload.page}&size=${payload.size}`
    )
    return res
  }
}
export async function getExternalApiDashboardInformationService () {
  const res = await axios.get(`${baseUrl}/dashboard`)
  return res
}
export async function getAllYieldOfferingProfilesService (payload) {
  const res = await axios.get(
    `${baseUrl}/yield-offering?page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function getYieldProfileByIdService (id) {
  const res = await axios.get(`${baseUrl}/yield-offering/${id}`)
  return res
}
export async function getTerminalSettlementsService (payload) {
  const res = await axios.get(
    `${baseUrl}/settlement/terminal?page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function createYieldProfileService (payload) {
  const res = await axios.post(`${baseUrl}/yield-offering`, { ...payload })
  return res
}
export async function editYieldProfileService (payload) {
  const res = await axios.put(`${baseUrl}/yield-offering`, { ...payload })
  return res
}
export async function getYieldProfileCustomersByIdService (payload) {
  const res = await axios.get(
    `${baseUrl}/customers?yieldOffering=${payload.id}&page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function getTreasuryTransactionsService (payload) {
  const res = await axios.get(
    `${baseUrl}/transactions?page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function getTerminalSettlementBatchDetailsService (payload) {
  const res = await axios.get(
    `${baseUrl}/transactions/terminal?currency=${payload.currency}&status=${payload.status}&batch_date=${payload.id}&page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function getTerminalTransactionsService (payload) {
  const res = await axios.get(
    `${baseUrl}/transactions/terminal?page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function cancelTerminalTransferBatchService (payload) {
  const res = await axios.patch(`${baseUrl}/terminal/cancel-batch`, {
    ...payload
  })
  return res
}
export async function cancelTreasuryDepositBatchService (payload) {
  const res = await axios.patch(`${baseUrl}/deposit/cancel-batch`, {
    ...payload
  })
  return res
}
export async function cancelTreasuryWithdrawalBatchService (payload) {
  const res = await axios.patch(`${baseUrl}/withdrawal/cancel-batch`, {
    ...payload
  })
  return res
}
export async function getTreasurySettlementsService (payload) {
  const res = await axios.get(
    `${baseUrl}/settlement/treasury?page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function getTreasurySettlementBatchDetailsService (payload) {
  const res = await axios.get(
    `${baseUrl}/transactions?currency=${payload.currency}&batch_date=${payload.id}&status=${payload.status}&type=${payload.type}&page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function settleCustomerTransferService (payload) {
  const res = await axios.post(`${baseUrl}/process-transfer`, { ...payload })
  return res
}
export async function settleCustomerAssetTransferService (payload) {
  const res = await axios.post(`${baseUrl}/process-asset-transfer`, {
    ...payload
  })
  return res
}
export async function settleCustomerDepositService (payload) {
  const res = await axios.post(`${baseUrl}/process-asset-deposit`, {
    ...payload
  })
  return res
}
export async function getPortfoliosService () {
  const res = await axios.get(`${baseUrl}/portfolio`)
  return res
}
export async function getCustomerDetailsTransactionsService (payload, type) {
  const hasFrom = payload.from ? `&from=${payload.from}` : ''
  const hasTo = payload.to ? `&to=${payload.to}` : ''
  const hasCurrency = payload.currency ? `&currency=${payload.currency}` : ''
  const res = await axios.get(
    `${baseUrl}/transactions?customerID=${payload.customerId}&type=${type}&page=${payload.page}&size=${payload.size}${hasFrom}${hasTo}${hasCurrency}`
  )
  return res
}
export async function getCustomerVirtualAccountService (payload) {
  const hasStatus = payload.status ? payload.status : ''
  const res = await axios.get(
    `${baseUrl}/accounts?customerID=${payload.customerId}&status=${hasStatus}&page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function getCustomerDetailsTransactionsByIDService (payload) {
  const res = await axios.get(
    `${baseUrl}/transactions/${payload.transactionType}/${payload.transactionId}`
  )
  return res
}
export async function whitelistIPsService (payload) {
  const res = await axios.post(`${baseUrl}/api-credential/ip`, { ...payload })
  return res
}
export async function deleteWhiteListedIPService (payload) {
  const res = await axios.delete(`${baseUrl}/api-credential/ip`, {
    data: { ...payload }
  })
  return res
}
